<template>
  <div>
    <v-dialog v-model="value" persistent max-width="800">
      <v-card>
        <div class="text-xs-right" @click="oncancel">
          <v-btn small flat fab><v-icon>close</v-icon></v-btn>
        </div>
        <v-card-text>
          <v-stepper v-model="step" vertical class="elevation-0">
            <v-stepper-step step="1" :complete="step > 1">
              {{ $t('Coupon Info') }}
            </v-stepper-step>
            <v-stepper-content step="1">
              <v-card class="elevation-0 mb-5">
                <div class="form-control" :class="{ 'has-error': errors.has('couponname') }">
                  {{ $t('Coupon Name') }}
                  <input
                    type="text"
                    maxlength="20"
                    v-model="coupon.name"
                    :placeholder="$t('Coupon Name')"
                    name="couponname"
                    :data-vv-as="$t('Coupon Name')"
                    v-validate="'required'"
                  />
                  <span class="text-error" v-if="errors.has('couponname')">{{
                    errors.first('couponname')
                  }}</span>
                </div>
                <div class="form-control" :class="{ 'has-error': errors.has('couponcode') }">
                  {{ $t('Coupon Code') }}
                  <input
                    type="text"
                    maxlength="10"
                    v-model="coupon.code"
                    :placeholder="$t('Coupon Code')"
                    :data-vv-as="$t('Coupon Code')"
                    style="text-transform: uppercase;"
                    name="couponcode"
                    @blur="onBlurCode"
                    v-validate="`required|excluded: ${excludeCoupons}`"
                  />
                  <span class="text-error" v-if="errors.has('couponcode')">{{
                    errors.first('couponcode')
                  }}</span>
                </div>
              </v-card>
              <div class="text-xs-center">
                <v-btn flat @click="oncancel">{{ $t('cancel') }}</v-btn>
                <v-btn color="primary" @click="nextStep(2)" depressed>{{ $t('Next') }}</v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-step step="2" :complete="step > 2">
              {{ $t('Coupon condition') }}
            </v-stepper-step>
            <v-stepper-content step="2">
              <v-card class="elevation-0 mb-5">
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pa-1">
                    <div class="caption">{{ $t('Type of discounts') }}</div>
                    <v-radio-group v-model="coupon.promotype" :data-vv-as="$t('Type of discounts')">
                      <v-radio
                        :label="$t('Price discount')"
                        :value="'price'"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('Quantity discount')"
                        :value="'piece'"
                        color="primary"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    class="form-control pa-1"
                    :class="{ 'has-error': errors.has('promovalue') }"
                  >
                    <template v-if="coupon.promotype == 'price'">
                      <div class="caption mb-1">{{ $t('Minimum purchase of') }}</div>
                      <v-layout>
                        <v-flex>
                          <input
                            type="number"
                            v-model="coupon.promovalue"
                            min="0"
                            maxlength="5"
                            max="99999"
                            placeholder="Price"
                            name="promovalue"
                            v-validate="'required|numeric'"
                          />
                          <span class="text-error" v-if="errors.has('promovalue')">{{
                            errors.first('promovalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Baht') }}</v-flex>
                      </v-layout>
                    </template>
                    <template v-else>
                      <div class="caption mb-1">{{ $t('Minimum of ... items') }}</div>
                      <v-layout>
                        <v-flex>
                          <input
                            type="number"
                            v-model="coupon.promovalue"
                            min="0"
                            maxlength="5"
                            max="99999"
                            placeholder="Count"
                            name="promovalue"
                            v-validate="'required|numeric'"
                          />

                          <span class="text-error" v-if="errors.has('promovalue')">{{
                            errors.first('promovalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Items') }}</v-flex>
                      </v-layout>
                    </template>
                  </v-flex>
                </v-layout>
                <v-divider class="mb-3"></v-divider>

                <v-layout wrap>
                  <v-flex xs12 sm6 class="pa-1">
                    <div class="caption">{{ $t('Discount for') }}</div>
                    <v-radio-group v-model="coupon.discounttype" :data-vv-as="$t('Discount for')">
                      <v-radio
                        :label="$t('Discount price')"
                        :value="'price'"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('Discount percent')"
                        :value="'percent'"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('Discount shipping fee')"
                        :value="'ship'"
                        color="primary"
                      ></v-radio>
                      <div style="display: flex;">
                        <v-radio style="height: 28px;" :value="'freeship'" color="primary">
                          <template slot="label">
                            {{ $t('Free Delivery') }}
                          </template>
                        </v-radio>
                        <v-checkbox
                          v-model="coupon.exclude_shipping_list"
                          v-if="coupon.discounttype === 'freeship'"
                          class="ml-3 mt-0 pa-0"
                          :label="$t('Except cash on delivery')"
                          color="primary"
                        ></v-checkbox>
                      </div>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm6 class="pa-1">
                    <template v-if="coupon.discounttype == 'price'">
                      <div class="caption mb-1">ลดราคา</div>
                      <v-layout>
                        <v-flex
                          class="form-control"
                          :class="{ 'has-error': errors.has('discountvalue') }"
                        >
                          <input
                            type="number"
                            min="0"
                            maxlength="5"
                            max="99999"
                            v-model="coupon.discountvalue"
                            placeholder="Price"
                            name="discountvalue"
                            v-validate="'required|numeric'"
                          />
                          <span class="text-error" v-if="errors.has('discountvalue')">{{
                            errors.first('discountvalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Baht') }}</v-flex>
                      </v-layout>
                    </template>
                    <template v-else-if="coupon.discounttype == 'percent'">
                      <div class="caption mb-1">{{ $t('Discount percent') }}</div>
                      <v-layout>
                        <v-flex
                          class="form-control"
                          :class="{ 'has-error': errors.has('discountvalue') }"
                        >
                          <input
                            type="number"
                            min="0"
                            max="100"
                            maxlength="3"
                            v-model="coupon.discountvalue"
                            placeholder="Price"
                            name="discountvalue"
                            v-validate="'required|numeric|max_value:100|min_value:1'"
                          />
                          <span class="text-error" v-if="errors.has('discountvalue')">{{
                            errors.first('discountvalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">%</v-flex>
                      </v-layout>
                      <div class="caption mb-1">{{ $t('maximum_discount_value') }}</div>
                      <v-layout>
                        <v-flex
                          class="form-control"
                          :class="{ 'has-error': errors.has('maximum_discount_value') }"
                        >
                          <input
                            type="number"
                            min="0"
                            v-model="coupon.maximum_discount_value"
                            placeholder="Price"
                            name="maximum_discount_value"
                            v-validate="'numeric'"
                          />
                          <span class="text-error" v-if="errors.has('maximum_discount_value')">{{
                            errors.first('maximum_discount_value')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">บาท</v-flex>
                      </v-layout>
                    </template>
                    <template v-else-if="coupon.discounttype == 'ship'">
                      <div class="caption mb-1">{{ $t('Discount shipping fee') }}</div>
                      <v-layout>
                        <v-flex
                          class="form-control"
                          :class="{ 'has-error': errors.has('discountvalue') }"
                        >
                          <input
                            type="number"
                            min="0"
                            maxlength="5"
                            max="99999"
                            v-model="coupon.discountvalue"
                            placeholder="Price"
                            name="discountvalue"
                            v-validate="'required|numeric|min_value:1'"
                          />
                          <span class="text-error" v-if="errors.has('discountvalue')">{{
                            errors.first('discountvalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Baht') }}</v-flex>
                      </v-layout>
                    </template>
                    <template v-else>
                      <div class="caption">{{ $t('Discount shipping fee') }}</div>
                      <div class="pa-2">
                        {{ $t('Free Delivery') }}
                        {{ coupon.exclude_shipping_list ? $t('Except cash on delivery') : '' }}
                      </div>
                    </template>
                  </v-flex>
                </v-layout>
              </v-card>
              <div class="text-xs-center">
                <v-btn flat @click="step = 1">{{ $t('Back') }}</v-btn>
              <v-btn color="primary" @click="nextStep(3)" depressed>{{ $t('Next') }}</v-btn>
            </div>
            </v-stepper-content>

            <v-stepper-step step="3" :complete="step > 3">
              {{ $t('Limit number of coupon used') }} ({{ $t('Optional') }})
            </v-stepper-step>
            <v-stepper-content step="3">
              <v-card class="elevation-0 mb-5">
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pa-1 form-control">
                    <div class="caption mb-1">{{ $t('1 person/ 1 time') }}</div>
                    <toggle-button
                      :value="coupon.onetimeuse"
                      :sync="true"
                      @change="coupon.onetimeuse = !coupon.onetimeuse"
                      :color="$vuetify.theme.success"
                      :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    />
                    <div>
                      <small class="primary--text">{{ $t('remark_code_salepage') }}</small>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6 class="pa-1 form-control">
                    <div class="caption mb-1">
                      {{ $t('Number of code that can be used in the campaign') }}
                    </div>
                    <v-layout>
                      <v-flex>
                        <input type="number" v-model="coupon.quantity" maxlength="9999" />
                      </v-flex>
                      <v-flex shrink>
                        <v-btn small fab flat class="my-0" @click="coupon.quantity = null">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider class="my-3" />
                {{ $t('Hide this coupon code') }}
                <toggle-button
                  class="ml-2"
                  :value="coupon.is_hidden"
                  :sync="true"
                  @change="coupon.is_hidden = !coupon.is_hidden"
                  :color="$vuetify.theme.success"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                />
                <v-divider class="my-3" />
                <div class="form-control" :class="{ 'has-error': errors.has('Expired date') }">
                  {{ $t('Validity for this promo code') }}

                  <!-- <v-layout class="mt-2"> -->
                  <!-- <v-flex class="pr-1"> -->
                  <div class="form-control mt-2">
                    <div class="caption mb-1">{{ $t('Turn-on Time') }}</div>
                    <v-layout wrap>
                      <v-flex
                        xs5
                        class="form-control"
                        :class="{ 'has-error': errors.has('startdate') }"
                      >
                        <v-menu
                          ref="openStartDate"
                          v-model="openStartDate"
                          :close-on-content-click="false"
                          full-width
                          max-width="290px"
                          color="primary"
                        >
                          <template v-slot:activator="{ on }">
                            <input
                              type="text"
                              class="form-control browser-default"
                              :placeholder="$t('Date')"
                              readonly
                              v-model="startDate"
                              v-on="on"
                              clearable
                              small
                            />
                          </template>
                          <v-date-picker
                            color="primary"
                            v-model="startDate"
                            @input="openStartDate = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs3 class="px-1">
                        <multiselect
                          class="time"
                          v-model="startTimeHours"
                          :options="optionsHours"
                          :searchable="false"
                          :close-on-select="true"
                          :show-labels="false"
                          :placeholder="$t('ชั่วโมง')"
                          :disabled="startDate == null"
                        ></multiselect>
                      </v-flex>
                      <v-flex xs3 class="px-1">
                        <multiselect
                          class="time"
                          v-model="startTimeMinute"
                          :options="optionsMinute"
                          :searchable="false"
                          :close-on-select="true"
                          :show-labels="false"
                          :placeholder="$t('นาที')"
                          :disabled="startDate == null"
                        ></multiselect>
                      </v-flex>
                      <v-flex xs1>
                        <v-btn
                          fab
                          flat
                          small
                          color="primary"
                          style="height: 35px; width: 35px"
                          @click="
                            startDate = null
                            startTimeHours = '00'
                            startTimeMinute = '00'
                          "
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                  <!-- </v-flex>
                    <v-flex class="pl-1"> -->
                  <div class="form-control">
                    <div class="caption mb-1">{{ $t('Turn-off Time') }}</div>
                    <v-layout wrap>
                      <v-flex
                        class="form-control"
                        xs5
                        :class="{ 'has-error': errors.has('enddate') }"
                      >
                        <v-menu
                          ref="openEndDate"
                          v-model="openEndDate"
                          :close-on-content-click="false"
                          full-width
                          max-width="290px"
                          color="primary"
                        >
                          <template v-slot:activator="{ on }">
                            <input
                              type="text"
                              class="form-control browser-default"
                              :placeholder="$t('Date')"
                              readonly
                              v-model="endDate"
                              v-on="on"
                              clearable
                            />
                          </template>
                          <v-date-picker
                            color="primary"
                            v-model="endDate"
                            @input="openEndDate = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs3 class="px-1">
                        <!-- <v-flex xs3 class="pl-1"> -->
                        <multiselect
                          class="time"
                          v-model="endTimeHours"
                          :options="optionsHours"
                          :searchable="false"
                          :close-on-select="true"
                          :show-labels="false"
                          :placeholder="$t('ชั่วโมง')"
                          :disabled="endDate == null"
                        ></multiselect>
                      </v-flex>
                      <v-flex xs3 class="px-1">
                        <multiselect
                          class="time"
                          v-model="endTimeMinute"
                          :options="optionsMinute"
                          :searchable="false"
                          :close-on-select="true"
                          :show-labels="false"
                          :placeholder="$t('นาที')"
                          :disabled="endDate == null"
                        ></multiselect>
                      </v-flex>
                      <!-- </v-flex> -->
                      <v-flex xs1>
                        <v-btn
                          fab
                          flat
                          small
                          color="primary"
                          style="height: 35px; width: 35px"
                          @click="
                            endDate = null
                            endTimeHours = '00'
                            endTimeMinute = '00'
                          "
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                  <!-- </v-flex> -->
                  <!-- </v-layout> -->
                </div>
                <v-divider class="my-3" />
                <v-layout>
                  <v-flex>
                    {{ $t('Specific category') }}
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn small outline color="primary" @click="showCategory = true">
                      <v-icon class="mr-2">add</v-icon> {{ $t('Add') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
                <div class="text-xs-center my-3" v-if="coupon.category.length == 0">
                  {{ $t('coupon for all category') }}
                </div>
                <template v-else>
                  <v-card style="border: 1px solid #eee">
                    <template v-for="(cat, index) in coupon.category">
                      <v-card-text :key="'category_' + cat.id">
                        <v-layout>
                          <v-flex class="pa-2">
                            {{ cat.name }}
                          </v-flex>
                          <v-btn flat fab small class="ma-0" @click="deleteCategory(cat)"
                            ><v-icon>close</v-icon></v-btn
                          >
                        </v-layout>
                      </v-card-text>
                      <v-divider
                        :key="'category_divider_' + cat.id"
                        v-if="coupon.category.length - 1 != index"
                      />
                    </template>
                  </v-card>
                </template>
                <v-divider class="my-3" />
                <v-layout>
                  <v-flex>
                    {{ $t('Specific product') }}
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn small outline color="primary" @click="showProducts = true">
                      <v-icon class="mr-2">add</v-icon> {{ $t('Add') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
                <div class="text-xs-center my-3" v-if="exact_product_ids.length == 0">
                  {{ $t('coupon for all product') }}
                </div>
                <template v-else>
                  <v-card style="border: 1px solid #eee">
                    <template v-for="(pro, index) in exact_product_ids">
                      <v-card-text :key="'product_' + pro.id">
                        <v-layout>
                          <v-flex class="pa-2">
                            {{ pro.name }}
                          </v-flex>
                          <v-btn flat fab small class="ma-0" @click="deleteProduct(pro)"
                            ><v-icon>close</v-icon></v-btn
                          >
                        </v-layout>
                      </v-card-text>
                      <v-divider
                        :key="'product_divider_' + pro.id"
                        v-if="exact_product_ids.length - 1 != index"
                      />
                    </template>
                  </v-card>
                </template>
              </v-card>
              <div class="text-xs-center">
                <v-btn flat @click="step = 2">{{ $t('Back') }}</v-btn>
                <v-btn color="primary" @click="onsave" depressed>{{ $t('Save') }}</v-btn>
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCategory" scrollable persistent max-width="1000">
      <v-card>
        <v-layout>
          <v-flex class="pa-1 form-control">
            <input type="text" v-model="search" :placeholder="$t('Search')" class="mb-0" />
          </v-flex>
          <v-flex shrink class="text-xs-right">
            <v-btn small fab flat @click="showCategory = false"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-divider />
        <v-card-text max-height="600">
          <div v-if="loadingCategory" class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
          <template v-if="filterCategory.length > 0">
            <div
              class="z-border-red"
              style="padding: 15px; margin-bottom: 15px; position: relative; cursor: pointer"
              v-for="(cat, index) in filterCategory"
              :key="'schedule_post_' + index"
            >
              <v-layout>
                <v-flex>
                  <div style="padding-left: 10px;word-break: break-all;">
                    {{ cat.name }}
                  </div>
                </v-flex>

                <v-flex shrink>
                  <v-btn small depressed @click="selectedCategory(cat)">
                    {{ $t('Select') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <div class="text-xs-center" v-else>
            No category
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showProducts" scrollable persistent max-width="1000">
      <v-card>
        <v-layout>
          <v-flex class="pa-1 form-control">
            <input type="text" v-model="search" :placeholder="$t('Search')" class="mb-0" />
          </v-flex>
          <v-flex shrink class="text-xs-right">
            <v-btn small fab flat @click="showProducts = false"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-divider />
        <v-card-text max-height="600">
          <div v-if="loadingCategory" class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
          <template v-if="filterProducts.length > 0">
            <div
              class="z-border-red"
              style="padding: 15px; margin-bottom: 15px; position: relative; cursor: pointer"
              v-for="(pro, index) in filterProducts"
              :key="'schedule_post_' + index"
            >
              <v-layout>
                <v-flex>
                  <div style="padding-left: 10px;word-break: break-all;">
                    {{ pro.name }}
                  </div>
                </v-flex>

                <v-flex shrink>
                  <v-btn small depressed @click="selectedProducts(pro)">
                    {{ $t('Select') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <div class="text-xs-center" v-else>
            No category
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

const dict = {
  en: {
    custom: {
      couponcode: {
        excluded: 'Duplicate Conversation Name'
      }
    }
  },
  th: {
    custom: {
      couponcode: {
        excluded: 'ชื่อบทสนทนาซ้ำ'
      }
    }
  },
  la: {
    custom: {
      couponcode: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ'
      }
    }
  }
}

export default {
  props: ['value', 'currentcoupon', 'coupons'],
  data() {
    return {
      optionsHours: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24'
      ],
      optionsMinute: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
        '39',
        '40',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48',
        '49',
        '50',
        '51',
        '52',
        '53',
        '54',
        '55',
        '56',
        '57',
        '58',
        '59',
      ],
      exact_product_ids: [],
      startDate: null,
      startTimeHours: '00',
      startTimeMinute: '00',
      endTimeHours: '00',
      endTimeMinute: '00',
      openStartDate: false,
      openStartTime: false,
      endDate: null,
      openEndDate: false,
      openEndTime: false,

      showCategory: false,
      showProducts: false,
      step: 1,
      search: '',
      promotypeOptions: ['price', 'piece'],
      discounttypeOptions: ['price', 'percent', 'ship', 'freeship'],
      coupon: {
        name: '', //
        code: '',
        promotype: 'price', // price or piece
        promovalue: 5, // numeric
        discounttype: 'price', // price,percent,ship,freeship
        discountvalue: '100', // numeric
        onetimeuse: true, // true,false
        category: [], // [{id:17465,name:"sadsad"},{....}]
        exact_product_ids: null,
        quantity: null, // limit 999
        status: true, // true,false
        is_hidden: false
      }
    }
  },
  created() {},
  mounted() {
    this.$validator.localize(dict)
    if (this.currentcoupon) {
      var coupon = this.currentcoupon
      try {
        coupon.category = JSON.parse(coupon.category)
      } catch (error) {}
      this.coupon = coupon

      this.startDate =
        this.coupon.startdate !== null ? dayjs(this.coupon.startdate).format('YYYY-MM-DD') : null
      this.startTimeHours =
        this.coupon.startdate !== null ? dayjs(this.coupon.startdate).format('HH') : '00'
      this.startTimeMinute =
        this.coupon.startdate !== null ? dayjs(this.coupon.startdate).format('mm') : '00'
      this.endDate =
        this.coupon.enddate !== null ? dayjs(this.coupon.enddate).format('YYYY-MM-DD') : null
      this.endTimeHours =
        this.coupon.enddate !== null ? dayjs(this.coupon.enddate).format('HH') : '00'
      this.endTimeMinute =
        this.coupon.enddate !== null ? dayjs(this.coupon.enddate).format('mm') : '00'
      this.exact_product_ids = coupon.exact_product_ids
        ? this.getProductById(coupon.exact_product_ids)
        : []
    }
  },
  components: {
    Multiselect,
    ToggleButton
  },
  computed: {
    ...mapGetters({
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory',
      products: 'getProducts'
    }),
    filterCategory() {
      if (!this.categories || this.categories.length == 0) return []
      var category = this.categories.filter(el => {
        return (
          !this.coupon ||
          !this.coupon.category ||
          this.coupon.category.length == 0 ||
          this.coupon.category.findIndex(cat => {
            return el.id == cat.id
          }) == -1
        )
      })

      if (this.search != '') {
        return category.filter(el => {
          return el.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return category
      }
    },

    filterProducts() {
      if (!this.products || this.products.length == 0) return []
      var products = this.products.filter(el => {
        return (
          !this.exact_product_ids ||
          this.exact_product_ids.length == 0 ||
          this.exact_product_ids.findIndex(pro => {
            return el.id == pro.id
          }) == -1
        )
      })

      if (this.search != '') {
        return products.filter(el => {
          return el.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return products
      }
    },
    excludeCoupons() {
      var coupons = this.coupons

      if (this.coupon && this.coupon.id) {
        coupons = coupons.filter(el => {
          return this.coupon.id != el.id
        })
      }

      if (coupons.length == 0) {
        return ''
      }

      return coupons
        .map(el => {
          return el.code
        })
        .join(',')
    }
  },
  filters: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    }
  },
  methods: {
    getProductById(id) {
      var array = id.split(',')
      var products = this.products.filter(product => {
        return (
          array.findIndex(pro => {
            return product.id == pro
          }) !== -1
        )
      })
      return products
    },
    onBlurCode() {
      this.$set(this.coupon, 'code', this.coupon.code.toUpperCase())
    },
    async nextStep(step) {
      var result = await this.$validator.validateAll()
      if (!result) {
        this.goToErrorInput()
        return false
      }

      this.step = step
    },
    deleteCategory(category) {
      var index = this.coupon.category.findIndex(el => {
        return el.id == category.id
      })
      if (index != -1) this.coupon.category.splice(index, 1)
    },
    deleteProduct(product) {
      var index = this.exact_product_ids.findIndex(el => {
        return el.id == product.id
      })
      if (index != -1) this.exact_product_ids.splice(index, 1)
    },
    selectedCategory(category) {
      this.coupon.category.push(category)
    },
    selectedProducts(product) {
      this.exact_product_ids.push(product)
    },

    onlyIDexactProduct(exact_product_ids) {
      var a = []
      exact_product_ids.map(item => {
        a.push(item.id)
      })
      return a.toString()
    },
    onsave() {
      const vm = this
      if (vm.coupon.discounttype !== 'percent') {
        vm.coupon.maximum_discount_value = ''
      }
      if (vm.startDate !== null && vm.startTimeHours !== null && vm.startTimeMinute !== null) {
        vm.$set(
          vm.coupon,
          'startdate',
          `${vm.startDate} ${vm.startTimeHours}:${vm.startTimeMinute}:00`
        )
      } else {
        if (vm.startDate !== null) {
          vm.$set(vm.coupon, 'startdate', `${vm.startDate} 00:00:00`)
        } else {
          vm.$set(vm.coupon, 'startdate', null)
        }
      }

      if (vm.endDate !== null && vm.endTimeHours !== null && vm.endTimeMinute !== null) {
        vm.$set(vm.coupon, 'enddate', `${vm.endDate} ${vm.endTimeHours}:${vm.endTimeMinute}:00`)
      } else {
        if (vm.endDate !== null) {
          vm.$set(vm.coupon, 'enddate', `${vm.endDate} 00:00:00`)
        } else {
          vm.$set(vm.coupon, 'enddate', null)
        }
      }
      vm.$set(vm.coupon, 'exact_product_ids', vm.onlyIDexactProduct(vm.exact_product_ids))
      vm.$set(vm.coupon, 'code', vm.coupon.code.toUpperCase())
      vm.$emit('onsave', vm.coupon)
      vm.coupon = {
        name: '', //
        code: '',
        promotype: 'price', // price or piece
        promovalue: 5, // numeric
        discounttype: 'price', // price,percent,ship,freeship
        discountvalue: '100', // numeric
        onetimeuse: true, // true,false
        category: [], // [{id:17465,name:"sadsad"},{....}]
        exact_product_ids: null,
        quantity: null, // limit 999
        status: true, // true,false
        startdate: null,
        enddate: null,
        is_hidden: false
      }
      vm.errors.clear()
      vm.step = 1
      vm.$emit('input', false)
    },
    oncancel() {
      this.coupon = {
        name: '', //
        code: '',
        promotype: 'price', // price or piece
        promovalue: 5, // numeric
        discounttype: 'price', // price,percent,ship,freeship
        discountvalue: '100', // numeric
        onetimeuse: true, // true,false
        category: [], // [{id:17465,name:"sadsad"},{....}]
        exact_product_ids: null,
        quantity: null, // limit 999
        status: true, // true,false
        startdate: null,
        enddate: null,
        is_hidden: false
      }
      this.errors.clear()
      this.step = 1
      this.$emit('input', false)
    },
    onKeyPress(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        (charCode < 65 || charCode > 90) &&
        (charCode < 97 || charCode > 122)
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  }
}
</script>

<style>
.multiselect__select {
    width: 0px !important;
    padding: 4px 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AddCoupon.vue